import { render, staticRenderFns } from "./JGPlatForm.vue?vue&type=template&id=3dbd61ef"
import script from "./JGPlatForm.vue?vue&type=script&lang=js"
export * from "./JGPlatForm.vue?vue&type=script&lang=js"
import style0 from "./JGPlatForm.vue?vue&type=style&index=0&id=3dbd61ef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports